import React, { Fragment } from 'react';
import styles from 'styles/modules/popUps/FileUpload.module.scss';
import FilePreview from 'components/FilePreview';
import SidescreenHeader from './SidescreenHeader';
import AddContent from 'components/Profile/AddContent';
import Uploader from 'components/Uploader';
import { profile } from 'lang/en.json';

const AddFiles = ({
    files,
    title,
    showUploadPopup,
    hideUploadPopup,
    activeUploadPopup,
}) => {
    const handleUploadSuccess = () => {
        hideUploadPopup();
    };

    return (
        <Fragment>
            <SidescreenHeader title={title}>
                <AddContent
                    className={'mr-xs'}
                    data={{
                        direction: 'row',
                        label: 'Add new file',
                        onClick: showUploadPopup,
                    }}
                />
            </SidescreenHeader>

            <Uploader
                isActive={activeUploadPopup}
                onCancel={hideUploadPopup}
                onSubmit={handleUploadSuccess}
                croppable={false}
                noSettings={false}
                allowedTypes={'files'}
            />

            {files.length < 1 && (
                <h3 className={styles.emptyBlock}>
                    {profile.mediaPack.empty_block}
                </h3>
            )}

            <div className={styles.fileGrid}>
                {files.map((file, index) => {
                    return (
                        <FilePreview
                            id={file.id}
                            title={file.title}
                            name={file.name}
                            key={`preview-file-${index}`}
                            url={file.path}
                        />
                    );
                })}
            </div>
        </Fragment>
    );
};

export default AddFiles;
